// src/components/Home.js

import React from 'react';
import Hero from './Hero';
import ContactUs from './ContactUs';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <ContactUs />
    </div>
  );
}

export default Home;
